angular.module('eficienciaFiscalModule')
    .service('ngCopy', ['$window', function ($window) {
        let body = angular.element($window.document.body);
        let textarea = angular.element('<textarea/>');
        textarea.css({position: 'fixed', opacity: '0'});

        return function (toCopy) {
            textarea.val(toCopy);
            body.append(textarea);
            textarea[0].select();

            try {
                let successful = document.execCommand('copy');
                if (!successful) throw successful;
            } catch (err) {
                window.prompt("Copie usando Ctrl+C, Enter", toCopy);
            }

            textarea.remove();
        }
    }])
    .directive('ngClickCopy', ['ngCopy', (ngCopy) => {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.tooltip()

                element.bind('click', () => {
                    ngCopy(attrs.ngClickCopy)

                    element.trigger('copied', ['Copiado!'])
                })

                if (element.context.tagName !== "A") {
                    element.bind('copied', function(event, message) {
                        setTimeout(() => {
                            $(this).attr('title', message)
                                .tooltip('fixTitle')
                                .tooltip('show')
                                .attr('title', "Copiar")
                                .tooltip('fixTitle');
                        }, 100)
                    });
                }
            }
        }
    }])
